import { Constants } from '@pwc/pwc-deals-web-common';
import {
  ProjectHttpClient,
  ProjectHttpClientV2,
  ContentServiceHttpClient,
} from '../../common/services/httpClient';
import { updateWorkflowStatus } from '../workflow/workflowService';

const baseServicePath = (projectId, topicThreadId, versionStatus) =>
  ['projects', projectId, 'topics', topicThreadId, versionStatus]
    .filter(Boolean)
    .join('/');

export const putTopic = async (projectId, topicThreadId, topicData) => {
  const response = await ProjectHttpClientV2.put(
    baseServicePath(projectId, topicThreadId),
    topicData
  );
  return response.data;
};

export const getPagedTopics = async (projectId, page = 0, pageSize = 10) => {
  const response = await ContentServiceHttpClient.get(
    `/projects/${projectId}/topics/latest?currentPage=${page}&pageSize=${pageSize}`
  );

  return response && response.data ? response.data : [];
};

export const getPagedSharedTopics = async (
  projectId,
  page = 0,
  pageSize = 10
) => {
  const response = await ContentServiceHttpClient.get(
    `/projects/${projectId}/topics/shared?currentPage=${page}&pageSize=${pageSize}&shared=Y`
  );

  return response && response.data ? response.data : [];
};

export const postTopic = async (projectId, topicData) => {
  const response = await ContentServiceHttpClient.post(
    `/projects/${projectId}/Topics`,
    topicData
  );

  return response.data;
};

export const getAllTopics = async (projectId) => {
  // TODO: use when the /contentapi/topics EP is completely ready
  // const response = await ContentServiceHttpClient.get(
  //   `projects/${projectId}/topics`
  // );

  // return response && response.data && response.data.items
  //   ? response.data.items
  //   : [];

  const response = await ProjectHttpClient.get(baseServicePath(projectId));
  return response.data;
};

export const getTopic = async (
  projectId,
  contentThreadId,
  contentId,
  versionStatus
) => {
  let url = baseServicePath(projectId, contentThreadId, versionStatus);
  let client = ProjectHttpClient;

  if (versionStatus === Constants.VERSION_STATUS.DRAFT.value) {
    url = `projects/${projectId}/contents/${contentId}/draft`;
    client = ContentServiceHttpClient;
  }

  if (versionStatus === Constants.VERSION_STATUS.SHARED.value) {
    url = `projects/${projectId}/contents/${contentId}/shared`;
    client = ContentServiceHttpClient;
  }

  const response = await client.get(url);
  return response.data;
};

export const deleteTopic = async (projectId, topicThreadId) => {
  const response = await ContentServiceHttpClient.delete(
    `/projects/${projectId}/contents/${topicThreadId}`
  );

  return response;
};

export const updateTopicStatus = async (
  projectId,
  topicThreadId,
  workflowAction
) => {
  const response = await updateWorkflowStatus(
    projectId,
    topicThreadId,
    workflowAction
  );

  return response.data;
};

export const getTopicVersions = async (projectId, topicThreadId) => {
  const response = await ContentServiceHttpClient.get(
    `projects/${projectId}/contents/${topicThreadId}/versions`
  );

  return response.data;
};

export const updateTopicOrderOld = async (projectId, topicOrder) => {
  const response = await ContentServiceHttpClient.post(
    `${baseServicePath(projectId)}/sortorder`,
    topicOrder
  );

  return response.data;
};

export const updateTopicOrder = async (
  projectId,
  topicThreadId,
  moveDirection
) => {
  const response = await ContentServiceHttpClient.post(
    `projects/${projectId}/Topics/${topicThreadId}/move/${moveDirection}`
  );

  return response.data;
};
